import type { HTMLAttributes } from "react";

import { HUB_MODAL_OVERLAY_Z_INDEX, HUB_NESTED_MODAL_OVERLAY_Z_INDEX } from "@/lib/viewportAnchoredPopover";
import { cn } from "@/lib/utils";

export type HubModalOverlayProps = HTMLAttributes<HTMLDivElement> & {
  /** When true, use the darker blurred backdrop (allocate / return flows). */
  dimmed?: boolean;
  "data-hub-modal-overlay"?: string;
};

/** Fixed full-viewport backdrop for portaled hub modals above {@link AnchoredDetailCallout}. */
export function hubModalOverlayClassName(dimmed = false): string {
  return cn(
    "fixed inset-0 flex min-h-0 items-start justify-center overflow-y-auto p-4",
    dimmed ? "bg-slate-950/70 backdrop-blur-sm" : "bg-slate-900/40",
  );
}

export function hubModalOverlayProps(dimmed = false): HubModalOverlayProps {
  return {
    "data-hub-modal-overlay": "",
    className: hubModalOverlayClassName(dimmed),
    style: { zIndex: HUB_MODAL_OVERLAY_Z_INDEX },
  };
}

/** Same shell as {@link hubModalOverlayProps}, stacked above an already-open hub modal. */
export function hubNestedModalOverlayProps(dimmed = true): HubModalOverlayProps {
  return {
    ...hubModalOverlayProps(dimmed),
    style: { zIndex: HUB_NESTED_MODAL_OVERLAY_Z_INDEX },
  };
}
